import { createContext } from 'react';

const proveedoresContext = createContext();

export default proveedoresContext;